import {
    SET_AGE_FILTER,
    SET_CLAN_MODE,
    SET_GAME_MODE,
    SET_PAGE_VALUE,
    SET_PLAYER_FILTER,
    SET_SERVER_MODE
} from "../reducer/connect";

// const [serverMode, setServerMode] = useStateWithGa4({init: {}, event: GA4_CLICKED_EVENT});
// const [playerFilter, setPlayerFilter] = useStateWithGa4({init: {}, event: GA4_CLICKED_EVENT});
// const [gameModeFilter, setGameModeFilter] = useStateWithGa4({init: {}, event: GA4_CLICKED_EVENT});
// const [clanModeFilter, setClanModeFilter] = useStateWithGa4({init: {}, event: GA4_CLICKED_EVENT});
// const [ageFilter, setAgeFilter] = useStateWithGa4({init: {}, event: GA4_CLICKED_EVENT});

const initialState = {
    serverMode: {},
    playerFilter: {},
    gameModeFilter: {},
    clanModeFilter: {},
    ageFilter: {},
    pageValue:1,
};

// 리듀서 (순수함수)
const connectReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SERVER_MODE: {
            return {
                ...state,
                serverMode: {...action.data}
            }
        }
        case SET_PLAYER_FILTER: {
            return {
                ...state,
                playerFilter: {...action.data}
            }
        }
        case SET_GAME_MODE: {
            return {
                ...state,
                gameModeFilter: {...action.data}
            }
        }
        case SET_CLAN_MODE: {
            return {
                ...state,
                clanModeFilter: {...action.data}
            }
        }
        case SET_AGE_FILTER: {
            return {
                ...state,
                ageFilter: {...action.data}
            }
        }
        case SET_PAGE_VALUE: {
            return {
                ...state,
                pageValue: action.data
            }
        }
        default:
            return state;
    }
};
export default connectReducer;
